import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import Nav from './Nav';
import SwitcherHeader from '../../elements/switcher/SwitcherHeader';
import { getLogoVariant } from '../../utils/logoAssets';
import { getAssetPath } from '../../utils/publicPath';

const BRAND_NAME = 'Mutawir Studios';

const MobileMenu = ({ MobileHandler, onNavigate }) => {
  const { t, i18n } = useTranslation();
  const lang = (i18n && i18n.language) ? i18n.language : undefined;
  const logos = getLogoVariant(lang);

  const handleNavigate = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  return (
    <div className="mobilemenu-popup">
      <div className="mobilemenu-inner">
        <div className="mobilemenu-header">
          <div className="mobile-nav-logo">
            <Link to="/" aria-label={BRAND_NAME} onClick={handleNavigate}>
              <img
                className="light-mode"
                src={getAssetPath(logos.light)}
                alt={`${BRAND_NAME} light logo`}
              />
              <img
                className="dark-mode"
                src={getAssetPath(logos.dark)}
                alt={`${BRAND_NAME} dark logo`}
              />
            </Link>
          </div>
          <div className="mobilemenu-actions">
            <button className="mobile-menu-close" onClick={MobileHandler} aria-label="Close menu">
              <FaTimes />
            </button>
          </div>
        </div>
        <div className="mobilemenu-body">
          <Nav onNavigate={handleNavigate} />
          <div className="mobilemenu-footer">
            <a className="axil-btn btn-fill-primary w-100" href={t('navigation.ctaHref')} onClick={handleNavigate}>
              {t('navigation.cta')}
            </a>
            <div className="mobilemenu-theme">
              <span>{t('navigation.themeToggle')}</span>
              <SwitcherHeader />
            </div>
            <div className="mobilemenu-language">
              <span>{t('navigation.languageToggle', { defaultValue: 'Language' })}</span>
              <div className="language-toggle">
                <button
                  type="button"
                  className={i18n.language && i18n.language.startsWith('en') ? 'is-active' : ''}
                  onClick={() => i18n.changeLanguage('en')}
                >
                  EN
                </button>
                <button
                  type="button"
                  className={i18n.language === 'ar' ? 'is-active' : ''}
                  onClick={() => i18n.changeLanguage('ar')}
                >
                  ع
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MobileMenu.propTypes = {
  MobileHandler: PropTypes.func,
  onNavigate: PropTypes.func
};

export default MobileMenu;
